import React, {useEffect, useState} from 'react';
import { H1, ProductImage } from './style';
import { useParams } from 'react-router-dom';
import AuthService from '../../../AuthService';
import { TiTick } from "react-icons/ti";
import { RxCross2 } from "react-icons/rx";
import { FiPackage, FiUser, FiMail, FiPhone, FiMapPin, FiDollarSign, FiCalendar, FiTruck, FiCheckCircle, FiX, FiClock, FiPrinter, FiDownload, FiUpload } from 'react-icons/fi';
import { MdStorefront, MdVerified } from 'react-icons/md';
import { FileUploader } from "react-drag-drop-files";
import { toast } from 'react-toastify';
import { Loader } from '../../Login/style';

export default function Order() {

    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);

    const {id} = useParams();

    const getOrder = async () => {
        setLoading(true);
        fetch(`https://api.rb.beeapp.es/admin/orders/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${AuthService.getToken()}`,
            },
        })
            .then(response => response.json())
            .then(data => {
                setOrder(data);
                setLoading(false);
            })
            .catch(error => {
                console.error(error);
                setLoading(false);
            });
    }

    useEffect(() => {
        getOrder();
    }, [id]);

    const handleChange = (file) => {
        const formData = new FormData();
        formData.append('invoice', file);
        formData.append('id', id);
        fetch(`https://api.rb.beeapp.es/admin/invoice`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${AuthService.getToken()}`,
            },
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                toast.success('Factura subida correctamente');
                getOrder();
            })
            .catch(error => {
                toast.error('Error al subir la factura');
            });
    };

    const updateStatus = async (status) => {
        fetch(`https://api.rb.beeapp.es/admin/orders/${id}/status`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${AuthService.getToken()}`,
            },
            body: JSON.stringify({
                Status: status,
            }),
        })
            .then(response => response.json())
            .then(data => {
                toast.success('Estado actualizado correctamente');
                getOrder();
            })
            .catch(error => {
                toast.error('Error al actualizar el estado');
            });
    }

    const markAsPaid = async () => {
        try {
            const response = await fetch(`https://api.rb.beeapp.es/admin/orders/${id}/payment`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${AuthService.getToken()}`,
                },
                body: JSON.stringify({
                    isPay: true,
                }),
            });

            if (response.ok) {
                toast.success('Pedido marcado como pagado correctamente');
                getOrder();
            } else {
                const errorData = await response.json();
                toast.error(`Error: ${errorData.message}`);
            }
        } catch (error) {
            console.error('Error marking order as paid:', error);
            toast.error('Error al marcar el pedido como pagado');
        }
    }

    const handlePrint = () => {
        const printWindow = window.open('', '', 'width=800,height=600');

        const printContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Pedido #${id?.slice(-8)}</title>
                <style>
                    body {
                        font-family: Arial, sans-serif;
                        padding: 20px;
                        color: #000;
                    }
                    .header {
                        margin-bottom: 20px;
                        border-bottom: 2px solid #028322;
                        padding-bottom: 15px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        flex-wrap: wrap;
                        gap: 15px;
                    }
                    .header h1 {
                        margin: 0;
                        font-size: 20px;
                        color: #028322;
                    }
                    .header-info {
                        display: flex;
                        gap: 20px;
                        align-items: center;
                        font-size: 13px;
                    }
                    .header-info > div {
                        white-space: nowrap;
                    }
                    .info-section {
                        margin-bottom: 20px;
                    }
                    .info-section h2 {
                        font-size: 16px;
                        color: #028322;
                        border-bottom: 1px solid #ccc;
                        padding-bottom: 5px;
                        margin-bottom: 10px;
                    }
                    .info-grid {
                        display: grid;
                        grid-template-columns: 150px 1fr;
                        gap: 8px;
                        margin-bottom: 10px;
                    }
                    .info-label {
                        font-weight: bold;
                    }
                    table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-top: 20px;
                    }
                    th {
                        background-color: #028322;
                        color: #000;
                        padding: 6px 8px;
                        text-align: left;
                        font-weight: bold;
                        font-size: 12px;
                    }
                    td {
                        padding: 6px 8px;
                        border-bottom: 1px solid #ddd;
                        font-size: 12px;
                    }
                    tr:nth-child(even) {
                        background-color: #f9f9f9;
                    }
                    .totals {
                        margin-top: 20px;
                        text-align: right;
                    }
                    .totals div {
                        margin: 5px 0;
                    }
                    .total-final {
                        font-size: 18px;
                        font-weight: bold;
                        color: #028322;
                        border-top: 2px solid #028322;
                        padding-top: 10px;
                        margin-top: 10px;
                    }
                    .watermark {
                        position: fixed;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%) rotate(-45deg);
                        font-size: 70px;
                        font-weight: bold;
                        color: rgba(220, 38, 38, 0.15);
                        z-index: 1000;
                        white-space: nowrap;
                        pointer-events: none;
                        letter-spacing: 8px;
                        text-transform: uppercase;
                    }
                    body {
                        position: relative;
                        z-index: 1;
                    }
                    @media print {
                        body { padding: 0; }
                        @page { margin: 2cm; }
                    }
                </style>
            </head>
            <body>
                ${!order?.isPay ? '<div class="watermark">PENDIENTE DE PAGO</div>' : ''}
                <div class="header">
                    <h1>PEDIDO #${id?.slice(-8)}</h1>
                    <div class="header-info">
                        <div>Fecha: <strong>${order?.CreationDate && new Date(order.CreationDate).toLocaleDateString('es-ES', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                        })}</strong></div>
                        <div>Estado: <strong>${statusInfo.text}</strong></div>
                    </div>
                </div>

                <div class="info-section">
                    <h2>Información del Cliente</h2>
                    <div class="info-grid">
                        <div class="info-label">Nombre:</div>
                        <div>${order?.UserID?.Name} ${order?.UserID?.Surname}</div>
                        <div class="info-label">Email:</div>
                        <div>${order?.UserID?.Email}</div>
                        <div class="info-label">Teléfono:</div>
                        <div>${order?.UserID?.Phone || '-'}</div>
                        <div class="info-label">CIF:</div>
                        <div>${order?.UserID?.CIF || '-'}</div>
                    </div>
                </div>

                ${order?.Address?.map((address) => `
                    <div class="info-section">
                        <h2>Dirección de Entrega</h2>
                        <div>${address.Address}</div>
                        <div>${address.City}, ${address.ZIP}</div>
                        <div>${address.Country}</div>
                    </div>
                `).join('') || ''}

                <div class="info-section">
                    <h2>Productos</h2>
                    <table>
                        <thead>
                            <tr>
                                <th style="text-align: center; width: 30px;">✓</th>
                                <th>Referencia</th>
                                <th>Producto</th>
                                <th style="text-align: center;">Cantidad</th>
                                <th style="text-align: right;">Precio/ud</th>
                                <th style="text-align: right;">Total</th>
                                <th style="text-align: center;">Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${order?.Products?.filter(p => p.product).map((product) => `
                                <tr>
                                    <td style="text-align: center;">
                                        <div style="width: 16px; height: 16px; border: 2px solid #333; display: inline-block; margin: auto;"></div>
                                    </td>
                                    <td>${product.product.reference || ''}</td>
                                    <td>${product.product.name || 'Producto no disponible'}</td>
                                    <td style="text-align: center;">${product.quantity}</td>
                                    <td style="text-align: right;">${product.price.toFixed(2)}€</td>
                                    <td style="text-align: right;"><strong>${(product.price * product.quantity).toFixed(2)}€</strong></td>
                                    <td style="text-align: center;">${product.prepared ? 'Preparado' : 'Pendiente'}</td>
                                </tr>
                            `).join('') || ''}
                        </tbody>
                    </table>
                </div>

                <div class="totals">
                    <div>Subtotal: <strong>${order?.TotalAmount?.toFixed(2)}€</strong></div>
                    <div>Gastos de envío: <strong>${order?.ShippingCosts || 0}€</strong></div>
                    <div>Subtotal con envío: <strong>${(order?.TotalAmount + order?.ShippingCosts).toFixed(2)}€</strong></div>
                    <div>IVA (21%): <strong>${((order?.TotalAmount + order?.ShippingCosts) * 0.21).toFixed(2)}€</strong></div>
                    <div class="total-final">TOTAL: ${((order?.TotalAmount + order?.ShippingCosts) * 1.21).toFixed(2)}€</div>
                </div>

                ${isBarOffice ? '<p style="margin-top: 30px; color: #1e40af;"><strong>Pedido BarOffice</strong></p>' : ''}
                ${order?.isPay ? '<p style="color: #16a34a;"><strong>PAGADO</strong></p>' : ''}
            </body>
            </html>
        `;

        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.focus();

        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 250);
    };

    const getStatusColor = (status) => {
        switch(status) {
            case 'Created': return { bg: '#fef3c7', color: '#f59e0b', border: '#fde68a', text: 'Pendiente' };
            case 'Preparing': return { bg: '#dbeafe', color: '#3b82f6', border: '#bfdbfe', text: 'Preparando' };
            case 'Shipped': return { bg: '#d1fae5', color: '#10b981', border: '#a7f3d0', text: 'Enviado' };
            case 'Delivered': return { bg: '#dcfce7', color: '#16a34a', border: '#bbf7d0', text: 'Entregado' };
            case 'Cancelled': return { bg: '#fee2e2', color: '#ef4444', border: '#fecaca', text: 'Cancelado' };
            default: return { bg: '#f3f4f6', color: '#6b7280', border: '#e5e7eb', text: status };
        }
    }

    const isBarOffice = order?.sourceApp === 'BarOffice';
    const statusInfo = getStatusColor(order?.Status);

    if (loading) {
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.3)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 100,
            }}>
                <div style={{
                    backgroundColor: '#fff',
                    padding: '32px',
                    borderRadius: '12px',
                    textAlign: 'center',
                }}>
                    <Loader />
                    <p style={{
                        marginTop: '16px',
                        color: '#6b7280',
                        fontSize: '14px',
                        fontFamily: 'Inter, sans-serif'
                    }}>
                        Cargando pedido...
                    </p>
                </div>
            </div>
        );
    }

    if (!order) {
        return (
            <div style={{ padding: '24px', textAlign: 'center' }}>
                <p>No se encontró el pedido</p>
            </div>
        );
    }

    return (
        <>
        <style jsx>{`
            @media print {
                .no-print {
                    display: none !important;
                }
                body {
                    background: white !important;
                }
            }
        `}</style>

        <div style={{
            padding: '24px',
            maxWidth: '1400px',
            margin: 'auto'
        }}>
            {/* Header */}
            <div style={{
                marginBottom: '32px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
                gap: '16px'
            }}>
                <div>
                    <H1 style={{ marginBottom: '8px' }}>Pedido #{id?.slice(-8)}</H1>
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                        <span style={{
                            padding: '6px 12px',
                            borderRadius: '8px',
                            fontSize: '12px',
                            fontWeight: '600',
                            backgroundColor: statusInfo.bg,
                            color: statusInfo.color,
                            border: `1px solid ${statusInfo.border}`,
                            fontFamily: 'Inter, sans-serif'
                        }}>
                            {statusInfo.text}
                        </span>

                        {isBarOffice && (
                            <span style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '12px',
                                fontWeight: '600',
                                backgroundColor: '#dbeafe',
                                color: '#1e40af',
                                border: '1px solid #bfdbfe',
                                fontFamily: 'Inter, sans-serif'
                            }}>
                                <MdStorefront size={14} />
                                BarOffice
                            </span>
                        )}

                        {order?.isPay && (
                            <span style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '12px',
                                fontWeight: '600',
                                backgroundColor: '#dcfce7',
                                color: '#16a34a',
                                border: '1px solid #bbf7d0',
                                fontFamily: 'Inter, sans-serif'
                            }}>
                                <MdVerified size={14} />
                                Pagado
                            </span>
                        )}
                    </div>
                </div>

                <div className="no-print" style={{ display: 'flex', gap: '12px' }}>
                    <button
                        onClick={handlePrint}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#fff',
                            color: '#028322',
                            border: '2px solid #028322',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '600',
                            fontFamily: 'Inter, sans-serif',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#028322';
                            e.target.style.color = '#fff';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = '#fff';
                            e.target.style.color = '#028322';
                        }}
                    >
                        <FiPrinter size={16} />
                        Imprimir
                    </button>
                </div>
            </div>

            {/* Summary Cards */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '16px',
                marginBottom: '24px'
            }}>
                <div style={{
                    backgroundColor: '#fff',
                    border: '2px solid #028322',
                    borderRadius: '12px',
                    padding: '20px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: '#f0fdf4',
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <FiDollarSign size={20} color="#028322" />
                        </div>
                        <div>
                            <p style={{ margin: 0, fontSize: '12px', color: '#6b7280', fontFamily: 'Inter, sans-serif' }}>
                                Subtotal
                            </p>
                            <p style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#111827', fontFamily: 'Inter, sans-serif' }}>
                                {order?.TotalAmount?.toFixed(2).replace('.', ',')}€
                            </p>
                        </div>
                    </div>
                </div>

                <div style={{
                    backgroundColor: '#fff',
                    border: '2px solid #f59e0b',
                    borderRadius: '12px',
                    padding: '20px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: '#fef3c7',
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <FiTruck size={20} color="#f59e0b" />
                        </div>
                        <div>
                            <p style={{ margin: 0, fontSize: '12px', color: '#6b7280', fontFamily: 'Inter, sans-serif' }}>
                                Envío
                            </p>
                            <p style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#111827', fontFamily: 'Inter, sans-serif' }}>
                                {order?.ShippingCosts || 0}€
                            </p>
                        </div>
                    </div>
                </div>

                <div style={{
                    backgroundColor: '#fff',
                    border: '2px solid #3b82f6',
                    borderRadius: '12px',
                    padding: '20px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: '#dbeafe',
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <FiCheckCircle size={20} color="#3b82f6" />
                        </div>
                        <div>
                            <p style={{ margin: 0, fontSize: '12px', color: '#6b7280', fontFamily: 'Inter, sans-serif' }}>
                                Total con IVA
                            </p>
                            <p style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#111827', fontFamily: 'Inter, sans-serif' }}>
                                {((order?.TotalAmount + order?.ShippingCosts) * 1.21)?.toFixed(2)}€
                            </p>
                        </div>
                    </div>
                </div>

                <div style={{
                    backgroundColor: '#fff',
                    border: '2px solid #6b7280',
                    borderRadius: '12px',
                    padding: '20px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: '#f3f4f6',
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <FiCalendar size={20} color="#6b7280" />
                        </div>
                        <div>
                            <p style={{ margin: 0, fontSize: '12px', color: '#6b7280', fontFamily: 'Inter, sans-serif' }}>
                                Fecha
                            </p>
                            <p style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: '#111827', fontFamily: 'Inter, sans-serif' }}>
                                {order?.CreationDate && new Date(order.CreationDate).toLocaleDateString('es-ES', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric'
                                })}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content Grid */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: '2fr 1fr',
                gap: '24px',
                marginBottom: '24px'
            }}>
                {/* Left Column */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                    {/* Customer Info */}
                    <div style={{
                        backgroundColor: '#fff',
                        border: '1px solid #e5e7eb',
                        borderRadius: '12px',
                        padding: '24px'
                    }}>
                        <h3 style={{
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#111827',
                            marginBottom: '20px',
                            fontFamily: 'Inter, sans-serif',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <FiUser size={20} color="#028322" />
                            Información del Cliente
                        </h3>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <FiUser size={16} color="#6b7280" />
                                <div>
                                    <p style={{ margin: 0, fontSize: '12px', color: '#9ca3af', fontFamily: 'Inter, sans-serif' }}>
                                        Cliente
                                    </p>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: '#111827', fontFamily: 'Inter, sans-serif' }}>
                                        {order?.UserID?.Name} {order?.UserID?.Surname}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <FiMail size={16} color="#6b7280" />
                                <div>
                                    <p style={{ margin: 0, fontSize: '12px', color: '#9ca3af', fontFamily: 'Inter, sans-serif' }}>
                                        Email
                                    </p>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500', color: '#111827', fontFamily: 'Inter, sans-serif' }}>
                                        {order?.UserID?.Email}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <FiPhone size={16} color="#6b7280" />
                                <div>
                                    <p style={{ margin: 0, fontSize: '12px', color: '#9ca3af', fontFamily: 'Inter, sans-serif' }}>
                                        Teléfono
                                    </p>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500', color: '#111827', fontFamily: 'Inter, sans-serif' }}>
                                        {order?.UserID?.Phone || '-'}
                                    </p>
                                </div>
                            </div>

                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gap: '12px',
                                marginTop: '8px',
                                padding: '12px',
                                backgroundColor: '#f9fafb',
                                borderRadius: '8px'
                            }}>
                                <div>
                                    <p style={{ margin: 0, fontSize: '12px', color: '#6b7280', fontFamily: 'Inter, sans-serif' }}>CIF</p>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: '#111827', fontFamily: 'Inter, sans-serif' }}>
                                        {order?.UserID?.CIF || '-'}
                                    </p>
                                </div>
                                <div>
                                    <p style={{ margin: 0, fontSize: '12px', color: '#6b7280', fontFamily: 'Inter, sans-serif' }}>Recargo Equiv.</p>
                                    <p style={{
                                        margin: 0,
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: order?.UserID?.EquivalenceSurcharge ? '#16a34a' : '#dc2626',
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        {order?.UserID?.EquivalenceSurcharge ? 'Sí' : 'No'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Shipping Address */}
                    {order?.Address?.map((address, index) => (
                        <div key={index} style={{
                            backgroundColor: '#fff',
                            border: '1px solid #e5e7eb',
                            borderRadius: '12px',
                            padding: '24px'
                        }}>
                            <h3 style={{
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#111827',
                                marginBottom: '16px',
                                fontFamily: 'Inter, sans-serif',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <FiMapPin size={20} color="#028322" />
                                Dirección de Entrega
                            </h3>

                            <div style={{
                                padding: '16px',
                                backgroundColor: '#f9fafb',
                                borderRadius: '8px',
                                borderLeft: '4px solid #028322'
                            }}>
                                <p style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: '#111827', fontFamily: 'Inter, sans-serif', marginBottom: '4px' }}>
                                    {address.Address}
                                </p>
                                <p style={{ margin: 0, fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, sans-serif' }}>
                                    {address.City}, {address.ZIP}
                                </p>
                                <p style={{ margin: 0, fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, sans-serif' }}>
                                    {address.Country}
                                </p>
                            </div>
                        </div>
                    ))}

                    {/* Products */}
                    <div style={{
                        backgroundColor: '#fff',
                        border: '1px solid #e5e7eb',
                        borderRadius: '12px',
                        padding: '24px'
                    }}>
                        <h3 style={{
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#111827',
                            marginBottom: '16px',
                            fontFamily: 'Inter, sans-serif',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <FiPackage size={20} color="#028322" />
                            Productos ({order?.Products?.length || 0})
                        </h3>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {order?.Products?.filter(p => p.product).map((product, index) => (
                                <div key={index} style={{
                                    display: 'flex',
                                    gap: '16px',
                                    padding: '16px',
                                    backgroundColor: '#f9fafb',
                                    borderRadius: '8px'
                                }}>
                                    <div style={{ flexShrink: 0 }}>
                                        <ProductImage
                                            src={product.product.images?.[0]}
                                            alt={product.product.name}
                                            style={{
                                                width: '80px',
                                                height: '80px',
                                                objectFit: 'cover',
                                                borderRadius: '8px',
                                                border: '1px solid #e5e7eb',
                                                display: 'block'
                                            }}
                                        />
                                    </div>

                                    <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                        <h4 style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#111827',
                                            margin: '0 0 8px 0',
                                            fontFamily: 'Inter, sans-serif',
                                            lineHeight: '1.4',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}>
                                            {product.product.name || 'Producto no disponible'}
                                        </h4>
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#6b7280',
                                            fontFamily: 'Inter, sans-serif',
                                            lineHeight: '1.6'
                                        }}>
                                            Ref: {product.product.reference || 'N/A'} • {product.quantity} uds • {product.price.toFixed(2)}€/ud
                                        </div>
                                    </div>

                                    <div style={{
                                        flexShrink: 0,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'flex-end',
                                        minWidth: '100px'
                                    }}>
                                        <p style={{
                                            margin: '0 0 8px 0',
                                            fontSize: '18px',
                                            fontWeight: '700',
                                            color: '#111827',
                                            fontFamily: 'Inter, sans-serif',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {(product.price * product.quantity).toFixed(2)}€
                                        </p>
                                        <span style={{
                                            fontSize: '12px',
                                            color: product.prepared ? '#16a34a' : '#dc2626',
                                            fontWeight: '600',
                                            fontFamily: 'Inter, sans-serif',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {product.prepared ? '✓ Preparado' : '⏳ Pendiente'}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Right Column - Actions */}
                <div className="no-print" style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                    {/* Actions */}
                    <div style={{
                        backgroundColor: '#fff',
                        border: '1px solid #e5e7eb',
                        borderRadius: '12px',
                        padding: '24px'
                    }}>
                        <h3 style={{
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#111827',
                            marginBottom: '16px',
                            fontFamily: 'Inter, sans-serif'
                        }}>
                            Acciones
                        </h3>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {isBarOffice && !order?.isPay && (
                                <button
                                    onClick={markAsPaid}
                                    style={{
                                        padding: '12px 16px',
                                        backgroundColor: '#028322',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        fontFamily: 'Inter, sans-serif',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#026d1b'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#028322'}
                                >
                                    <FiCheckCircle size={16} />
                                    Marcar como Pagado
                                </button>
                            )}

                            {order?.Status !== 'Shipped' && order?.Status !== 'Delivered' && (
                                <>
                                    <button
                                        onClick={() => updateStatus('Shipped')}
                                        style={{
                                            padding: '12px 16px',
                                            backgroundColor: '#10b981',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '8px',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            fontFamily: 'Inter, sans-serif',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#059669'}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = '#10b981'}
                                    >
                                        <FiTruck size={16} />
                                        Marcar como Enviado
                                    </button>

                                    <button
                                        onClick={() => updateStatus('Preparing')}
                                        style={{
                                            padding: '12px 16px',
                                            backgroundColor: '#fff',
                                            color: '#3b82f6',
                                            border: '2px solid #3b82f6',
                                            borderRadius: '8px',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            fontFamily: 'Inter, sans-serif',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#3b82f6';
                                            e.target.style.color = '#fff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = '#fff';
                                            e.target.style.color = '#3b82f6';
                                        }}
                                    >
                                        <FiClock size={16} />
                                        Preparando
                                    </button>
                                </>
                            )}

                            <button
                                onClick={() => updateStatus('Cancelled')}
                                style={{
                                    padding: '12px 16px',
                                    backgroundColor: '#fff',
                                    color: '#ef4444',
                                    border: '2px solid #ef4444',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    fontFamily: 'Inter, sans-serif',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#ef4444';
                                    e.target.style.color = '#fff';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#fff';
                                    e.target.style.color = '#ef4444';
                                }}
                            >
                                <FiX size={16} />
                                Cancelar Pedido
                            </button>
                        </div>
                    </div>

                    {/* Billing */}
                    <div style={{
                        backgroundColor: '#fff',
                        border: '1px solid #e5e7eb',
                        borderRadius: '12px',
                        padding: '24px'
                    }}>
                        <h3 style={{
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#111827',
                            marginBottom: '16px',
                            fontFamily: 'Inter, sans-serif'
                        }}>
                            Facturación
                        </h3>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {order?.Billings?.length > 0 && order.Billings.map((billing, index) => (
                                <button
                                    key={index}
                                    onClick={() => window.open(billing.BillURL)}
                                    style={{
                                        padding: '12px 16px',
                                        backgroundColor: '#f59e0b',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        fontFamily: 'Inter, sans-serif',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#d97706'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#f59e0b'}
                                >
                                    <FiDownload size={16} />
                                    Factura #{index + 1}
                                </button>
                            ))}

                            <div style={{
                                border: '2px dashed #e5e7eb',
                                borderRadius: '8px',
                                padding: '16px',
                                textAlign: 'center',
                                backgroundColor: '#f9fafb'
                            }}>
                                <FileUploader
                                    handleChange={handleChange}
                                    name="invoice"
                                    types={['PDF']}
                                    label="Subir factura (PDF)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}
